<template lang="pug">
div.white.round-lg.pa-8(:style="`width:500px; min-height: ${isPatientLabel ? '300' : '600'}px; text-align: initial;`")
  document-template-header-preview.mb-4(v-if="hasHeader" :logo="logo" :address="address")
  template(v-if="category === 'medical_document'")
    div.neutral700--text.template-styling(v-html="content")
  template(v-if="category === 'medical_certificate'")
    document-template-medical-certificate-preview(:medicalCertificateData="medicalCertificateData")
  template(v-if="category === 'invoice'")
    document-template-invoice-preview(:invoiceData="invoiceData")
  template(v-if="category === 'receipt'")
    document-template-receipt-preview(:receiptData="receiptData")
  template(v-if="category === 'prescription_letter'")
    document-template-prescription-letter-preview(:prescriptionLetterData="prescriptionLetterData")
  template(v-if="category === 'patient_label'")
    v-card.pa-2(outlined style="border-color: var(--v-neutral500); min-height: 100px;")
      div.neutral700--text.template-styling(v-html="content")
  template(v-if="!isPatientLabel")
    document-template-footer-preview.my-4(v-if="footerUrl" :footerUrl="footerUrl" :footerAlignment="footerAlignment")
</template>

<script>
import DocumentTemplateHeaderPreview from '@/components/clinic/document/preview/DocumentTemplateHeaderPreview.vue'
import DocumentTemplateInvoicePreview from '@/components/clinic/document/preview/DocumentTemplateInvoicePreview.vue'
import DocumentTemplateReceiptPreview from '@/components/clinic/document/preview/DocumentTemplateReceiptPreview.vue'
import DocumentTemplateFooterPreview from '@/components/clinic/document/preview/DocumentTemplateFooterPreview.vue'
import DocumentTemplateMedicalCertificatePreview from '@/components/clinic/document/preview/DocumentTemplateMedicalCertificatePreview.vue'
import DocumentTemplatePrescriptionLetterPreview from '@/components/clinic/document/preview/DocumentTemplatePrescriptionLetterPreview.vue'

export default {
  components: {
    DocumentTemplateHeaderPreview, DocumentTemplateInvoicePreview, DocumentTemplateReceiptPreview, DocumentTemplateFooterPreview,
    DocumentTemplateMedicalCertificatePreview, DocumentTemplatePrescriptionLetterPreview
  },
  props: {
    header: {
      type: Object,
      default: () => {
        return {}
      }
    },
    category: {
      type: String,
      default: 'medical_document',
      validator(value) {
        return ['medical_document', 'medical_certificate', 'invoice', 'receipt', 'prescription_letter', 'patient_label'].includes(value)
      }
    },
    content: {
      type: String,
      default: null
    },
    invoiceData: {
      type: Array,
      default: () => {
        return []
      }
    },
    receiptData: {
      type: Array,
      default: () => {
        return []
      }
    },
    medicalCertificateData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    prescriptionLetterData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    footerUrl: {
      type: String,
      default: null
    },
    footerAlignment: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isPatientLabel () {
      return this.category === 'patient_label'
    },
    logo () {
      return this.header?.resizeImageFileUrl ?? null
    },
    address () {
      if (this.header.address) {
        return {
          ...this.header.address,
          name: this.header.name,
          phone: this.header.phone
        }
      }
      return null
    },
    hasHeader () {
      if (this.isPatientLabel) {
        return false
      }
      return this.logo || this.address
    },
  },
}
</script>

<style scoped>
.template-styling {
  line-height: 17px !important;
}
</style>